<div class="category p-4 container direction-right">
    <div class="row bg-light-gray rounded">
        <div class="col-12 p-4">
            <div class="control-section" *ngIf="isAdmin">
                <div class="d-flex justify-content-between align-items-center">
                    <div class="px-0 col-auto">
                        <button (click)="createNewFolder()" class="btn btn-primary px-4 px-lg-5" style="direction: ltr;">
                            <i class="fa fa-plus" aria-hidden="true">
                            </i>
                            {{'categories.new_folder' | translate}}
                        </button>
                    </div>
<!--                    <div class="d-none d-md-flex col-3"></div>-->
<!--                    <div class="d-flex col-auto">-->
<!--                        <div class="col-auto ">-->
<!--                            <i class="fa fa-2x fa-angle-up text-primary" role="button" [class.disabled]="!selectedItem"-->
<!--                               (click)="moveUpSubj.next(selectedItem)" aria-hidden="true"></i>-->
<!--                        </div>-->
<!--                        <div class="col-auto">-->
<!--                            <i class="fa fa-2x fa-angle-down text-primary" [class.disabled]="!selectedItem"-->
<!--                               (click)="moveDownSubj.next(selectedItem)" role="button"></i>-->
<!--                        </div>-->
<!--                    </div>-->
                    <div class="col-auto pr-0">
                        <div class="d-flex align-items-center">

                            <div class="col-auto">
                                <i class="fas fa-lg fa-edit text-primary" role="button" [class.disabled]="!selectedItem"
                                   (click)="selectedItem? editFolder(): null" aria-hidden="true"></i>
                            </div>
                            <!-- <div class="col-auto">
                              <i class="fas fa-lg fa-plus text-primary"
                                 [class.disabled]="!selectedItem"
                                 role="button"></i>
                            </div> -->
                            <button style="border-radius: 2rem;" class="btn btn-primary px-3 py-0"
                                    [class.btn-info]="!selectedItem || selectedItem?.children?.length" (click)="removeFolder()"
                                    [disabled]="!selectedItem || selectedItem?.children?.length">
                                <i class="fas fa-lg fa-times"></i>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <hr class="bg-primary" *ngIf="isAdmin">
            <h2>תיקיות</h2>
            <mat-grid-list cols="5" rowHeight="100px">
                <mat-grid-tile *ngFor="let folder of folders">
                    <mat-card class="folder-card" (click)="selectFolder(folder)">
                        <mat-card-content>{{ folder.name }}</mat-card-content>
                    </mat-card>
                </mat-grid-tile>
            </mat-grid-list>

            <div *ngIf="selectedFolder">
                <h2>קבצים בתוך "{{ selectedFolder.name }}"</h2>
                <mat-grid-list cols="5" rowHeight="200px">
                    <mat-grid-tile *ngFor="let file of getSelectedFolderFiles()">
                        <mat-card class="file-card">
                            <img [src]="file.image" alt="file image">
                            <mat-card-content>{{ file.name }}</mat-card-content>
                        </mat-card>
                    </mat-grid-tile>
                </mat-grid-list>
            </div>


        </div>
    </div>
</div>



